// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import RichTextBlock from '@uswitch/ev-components/lib/components/modules/rich-text-block'
import SingleColumnRichText from './platinum-modules/single-column-rich-text'
import { Fragment } from 'react'
import TwoColumnRichText from './platinum-modules/two-column-rich-text'
import { brand } from '@r/app-selectors'
import { connect } from 'react-redux'

const RichText = (props) => {
  const { content: document, contentTwo: documentTwo, heading, variant = undefined } = props
  if (variant === 'platinum') {
    if (document && !documentTwo) {
      return <SingleColumnRichText {...props} />
    }

    if (document && documentTwo) {
      return <TwoColumnRichText {...props} />
    }
    if (heading) {
      return <SingleColumnRichText {...props} />
    } else {
      return <Fragment></Fragment>
    }
  }
  return <RichTextBlock {...props} />
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(RichText)
